import Helper from '@ember/component/helper'
import { service } from '@ember/service'
import { isMathseedsPrimeThread } from 'teacher-ui-client/progression-sequence/utils'
import formatMathseedsPrimeLessonCode from 'teacher-ui-client/utils/format-mathseeds-prime-lesson-code'
import type { IntlService } from 'ember-intl'

interface Signature {
  Args: {
    Positional: unknown[]
  }
  Return: string | undefined
}

export class FormatMathseedsPrimeLessonCode extends Helper<Signature> {
  @service intl!: IntlService

  compute([thread, unit, lesson]: Signature['Args']['Positional']) {
    if (
      typeof thread === 'string' &&
      isMathseedsPrimeThread(thread) &&
      typeof unit === 'number' &&
      typeof lesson === 'number'
    ) {
      return formatMathseedsPrimeLessonCode(this.intl, thread, unit, lesson)
    }
  }
}

export default FormatMathseedsPrimeLessonCode
